<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :form-fields="formFields"
                  :permission="permission" :searchs="searchs" ref="table"/>
  </div>
</template>

<script>
import CommonTable from "../../components/CommonTable/CommonTable";

export default {
  name: "RaffleActivityTime",
  components: {CommonTable},
  data() {
    return {
      searchs: [
        {
          name: 'agentId',
          placeholder: '代理',
          type: 'select',
          selectUrl: '/agent/getAll',
          selectData: [],
        },
        {
          name: 'status',
          placeholder: '请选择类型',
          type: 'select',
          selectValue: [{
            key: 0,
            value: '未开始'
          }, {
            key: 1,
            value: '活动中'
          }, {
            key: 2,
            value: '已结束'
          }]
        }
      ],
      permission: {
        add: 'raffleActivityTime:add',
        update: 'raffleActivityTime:update',
        delete: 'raffleActivityTime:delete',
        deleteBatch: 'raffleActivityTime:deleteBatch'
      },
      url: {
        get: '/raffleActivityTime/listByCondition',
        add: '/raffleActivityTime/add',
        update: '/raffleActivityTime/update',
        delete: '/raffleActivityTime/delete',
        delete_batch: '/raffleActivityTime/deleteBatch'
      },
      tableColumns: [{
        field: 'id',
        label: 'ID',
        show: true,
        width: '75',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        detail: false,
        width: '',
      }, {
        field: 'status',
        label: '活动状态',
        show: {
          type: 'tag',
          tags: [{
            key: 0,
            value: '未开始',
          }, {
            key: 1,
            value: '活动中',
          }, {
            key: 2,
            value: '已结束',
          }]
        },
      }, {
        field: 'startTime',
        label: '活动开始时间',
        show: true,
        width: '',
      }, {
        field: 'endTime',
        label: '活动结束时间',
        show: true,
        width: '',
      }, {
        field: 'createTime',
        label: '时间',
        show: true,
        width: '',
      }],
      formFields: {
        addTitle: '添加活动时间',
        updateTitle: '修改活动时间',
        labelWidth: '90px',
        model: [{
          field: 'agentId',
          label: '代理：',
          type: 'select',
          placeholder: '请选择代理',
          rules: [{required: true, message: '请选择代理', trigger: 'blur'}],
          selectUrl: '/agent/getAll',
          selectData: [],
          add: true,
          update: true,
          filterable: true,
        }, /*{
          field: 'status',
          label: '类型',
          type: 'select',
          selectData: [{
            id: 0,
            name: '未开始',
          }, {
            id: 1,
            name: '活动中',
          }, {
            id: 2,
            name: '已结束',
          }],
          placeholder: '请选择',
          rules: [{
            message: '请选择', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        },*/
          {
            field: 'startTime',
            label: '活动开始时间',
            type: 'dateTime',
            placeholder: '活动开始时间',
            rules: [{message: '请输入活动开始时间', trigger: 'blur', required: true}],
            add: true,
            update: true,
          },
          {
            field: 'endTime',
            label: '活动结束时间：',
            type: 'dateTime',
            placeholder: '活动结束时间',
            rules: [{
              message: '请输入活动结束时间', trigger: 'blur', required: true
            }],
            add: true,
            update: true
          }]
      }
    }
  },
}
</script>

<style scoped>

</style>
